import React from 'react';
import axios from 'axios';
import i18n from '../../../i18n';
import { ROOT_URL } from 'constants/Config.js';

export const firstLetterToUpper = (str) => str.substring(0, 1).toUpperCase() + str.substring(1);

export const getLotsValues = (t) => [
  t('components.collection.showAllLots'),
  t('components.collection.onlySelectedLots'),
  t('components.collection.withoutLots'),
];

export const getBuildingType = (type) => {
  if (type === 2) {
    return i18n.t('common.kp');
  }

  return i18n.t('common.jk');
};

export const SectionsMap = {
  nameAddress: 'nameAddress',
  description: 'description',
  characteristics: 'characteristics',
  communications: 'communications',
  checkout: 'checkout',
  payment: 'payment',
  map: 'map',
  lots: 'lots',
  withoutLots: 'withoutLots',
  allLots: 'allLots',
  selectedLots: 'selectedLots',
  contacts: 'contacts',
};

export const makeBase64 = async (data) => {
  const { values, ...rest } = data;
  const keys = Object.keys(values).filter((key) => !values[key] || key === 'lots');
  const lotsValues = getLotsValues(i18n.t);

  const obj = {
    ...rest,
  };

  keys.forEach((key) => {
    const index = SectionsMap[key];

    if (index === 'lots') {
      switch (values[index]) {
        case lotsValues[0]: {
          obj.selectedLots = 1;
          obj.withoutLots = 1;
          break;
        }
        case lotsValues[1]: {
          obj.allLots = 1;
          obj.withoutLots = 1;
          break;
        }
        case lotsValues[2]: {
          obj.allLots = 1;
          obj.selectedLots = 1;
          break;
        }
        case false: {
          obj[index] = 1;
          break;
        }
      }
    } else {
      obj[index] = 1;
    }
  });

  const response = await axios.post(`${ROOT_URL}/selection/short/link`, { data: obj });

  return response.data.data.hash;
};

const paramsCache = {};
export const getParams = async (hash) => {
  const response = await axios.get(`${ROOT_URL}/selection/short/link?hash=${hash}`);

  if (response.data.data.resp) {
    paramsCache[hash] = response.data.data.resp;
  }

  return paramsCache[hash] || {};
};

const getDataByHash = () => {
  const [, , base64] = window.location.pathname.split('/');
  return paramsCache[base64] || {};
};

export const isSectionAllowed = (sectionName) => {
  if (['/ncollection/', '/nbref/'].findIndex((url) => location.pathname.includes(url)) === -1) {
    return true;
  }

  let innerSectionName = sectionName;
  const data = getDataByHash();

  if (sectionName === 'map' && location.pathname.includes('/nbref/')) {
    /*
      Для старых ссылок у тех, кто не обновил андроид и айос клиента
      Нужно удалить следующий if при следующем редактировании функции
     */
    if (data.map) {
      return false;
    }

    // В шаринге объекта за карту отвечает nameAddress
    innerSectionName = 'nameAddress';
  }

  const isHided = data[innerSectionName] == 1 || false;
  return !isHided;
};

export const ALL_LOTS = 2;
export const SELECTED_LOTS = 1;
export const WITHOUT_LOTS = 0;

export const getLotsType = () => {
  if (['/ncollection/', '/nbref/'].findIndex((url) => location.pathname.includes(url)) === -1) {
    return ALL_LOTS;
  }

  if (location.pathname.includes('nbref')) {
    return isSectionAllowed('lots') ? ALL_LOTS : WITHOUT_LOTS;
  }

  if (isSectionAllowed('withoutLots')) {
    return WITHOUT_LOTS;
  }

  if (isSectionAllowed('selectedLots')) {
    return SELECTED_LOTS;
  }

  return ALL_LOTS;
};

export const linkifyText = (text, maxLength) => {
  if (!text) return [];

  const message = [];
  let totalLength = 0;

  const getUnicodeLength = (str) => Array.from(str).length;

  const safeSlice = (str, maxLen) => {
    if (!maxLen || getUnicodeLength(str) <= maxLen) {
      return str;
    }
    const chars = Array.from(str);
    return `${chars.slice(0, maxLen).join('')}…`;
  };

  const parts = [];
  let processedText = text;
  const markdownLinkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  const markdownLinks = [];
  let markdownIndex = 0;

  processedText = processedText.replace(markdownLinkRegex, (match, linkText, url) => {
    const placeholder = `__MD_LINK_${markdownIndex}__`;
    markdownLinks.push({ text: linkText, url });
    markdownIndex += 1;
    return placeholder;
  });

  const plainUrlRegex =
    /((?:https?:\/\/|ftps?:\/\/|\bwww\.)(?:(?![.,?!;:()]*(?:\s|$))[^\s]){2,})/gimu;

  let lastIndex = 0;
  let match = plainUrlRegex.exec(processedText);

  while (match !== null) {
    if (match.index > lastIndex) {
      const textPart = processedText.substring(lastIndex, match.index);
      if (textPart) {
        parts.push({ type: 'text', content: textPart });
      }
    }

    parts.push({ type: 'url', content: match[0] });
    lastIndex = match.index + match[0].length;
    match = plainUrlRegex.exec(processedText);
  }

  if (lastIndex < processedText.length) {
    const textPart = processedText.substring(lastIndex);
    if (textPart) {
      parts.push({ type: 'text', content: textPart });
    }
  }

  if (parts.length === 0) {
    parts.push({ type: 'text', content: processedText });
  }

  const finalParts = [];
  parts.forEach((part) => {
    if (part.type === 'text') {
      const textContent = part.content;
      const mdPlaceholderRegex = /__MD_LINK_(\d+)__/g;
      let textLastIndex = 0;
      let mdMatch = mdPlaceholderRegex.exec(textContent);

      while (mdMatch !== null) {
        if (mdMatch.index > textLastIndex) {
          const beforeText = textContent.substring(textLastIndex, mdMatch.index);
          if (beforeText) {
            finalParts.push({ type: 'text', content: beforeText });
          }
        }

        const linkIndex = parseInt(mdMatch[0].match(/\d+/)[0], 10);
        if (markdownLinks[linkIndex]) {
          finalParts.push({
            type: 'markdown',
            text: markdownLinks[linkIndex].text,
            url: markdownLinks[linkIndex].url,
          });
        }

        textLastIndex = mdMatch.index + mdMatch[0].length;
        mdMatch = mdPlaceholderRegex.exec(textContent);
      }

      if (textLastIndex < textContent.length) {
        const afterText = textContent.substring(textLastIndex);
        if (afterText) {
          finalParts.push({ type: 'text', content: afterText });
        }
      }
    } else {
      finalParts.push(part);
    }
  });

  finalParts.forEach((part) => {
    if (maxLength && totalLength >= maxLength) {
      return;
    }

    if (part.type === 'markdown') {
      const href = part.url.startsWith('www.') ? `//${part.url}` : part.url;
      const linkLength = getUnicodeLength(part.text);

      if (maxLength && totalLength + linkLength > maxLength) {
        const remaining = maxLength - totalLength;
        if (remaining > 0) {
          message.push('…');
        }
        totalLength = maxLength;
        return;
      }

      message.push(
        <a key={message.length} target="_blank" rel="noopener noreferrer" href={href}>
          {part.text}
        </a>
      );
      totalLength += linkLength;
    } else if (part.type === 'url') {
      const href = part.content.startsWith('www.') ? `//${part.content}` : part.content;
      const linkLength = getUnicodeLength(part.content);

      if (maxLength && totalLength + linkLength > maxLength) {
        const remaining = maxLength - totalLength;
        if (remaining > 0) {
          message.push('…');
        }
        totalLength = maxLength;
        return;
      }

      message.push(
        <a key={message.length} target="_blank" rel="noopener noreferrer" href={href}>
          {part.content}
        </a>
      );
      totalLength += linkLength;
    } else if (part.type === 'text') {
      const textLength = getUnicodeLength(part.content);
      const remainingLength = maxLength ? maxLength - totalLength : textLength;

      if (maxLength && textLength > remainingLength) {
        const trimmed = safeSlice(part.content, remainingLength);
        message.push(trimmed);
        totalLength = maxLength;
      } else {
        message.push(part.content);
        totalLength += textLength;
      }
    }
  });

  return message;
};



// WEBPACK FOOTER //
// ./src/components/Building/Main/helper.js